<template>
  <b-container>
    <b-row class="col-sm-12 col-md-12 col-lg-12 story ">
      <div>
        <h2>Die Besten OZG-Umsetzer</h2>
        <b-table
          :fields="fields"
          :items="items"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        ></b-table></div></b-row
  ></b-container>
</template>

<script>
export default {
  name: "BestCityTable",
  data() {
    return {
      sortBy: "serviceFeatureCount",
      sortDesc: true,
      fields: [
        {
          key: "county",
          label: "Bundesland"
        },
        {
          // A regular column with custom formatter
          key: "bestCity",
          label: "Stadt"
        },
        {
          // A virtual column with custom formatter
          key: "serviceFeatureCount",
          label: "Anzahl der LeiKa-Leistungen",
          sortable: true,
          formatter: "countFormatter"
        }
      ],
      items: {}
    };
  },
  watch: {
    aggregateTopCityPerCounty: function(newVal) {
      this.items = newVal;
    }
  },

  methods: {
    countFormatter(value, key, item) {
      return `${item.serviceFeatureCount} (${item.onlineServiceCount})`;
    }
  },
  apollo: {
    $client: "ozgClient",
    aggregateTopCityPerCounty: {
      query() {
        return require("../../graphql/aggregateTopCityPerCounty.gql");
      }
    }
  }
};
</script>

<style scoped></style>
